import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const isLogin = localStorage.getItem("isLoggedIn") === "true";
    const loginDataRaw = localStorage.getItem("loginData");

    if (isLogin && loginDataRaw) {
      try {
        const loginData = JSON.parse(loginDataRaw);
        if (loginData?.accessToken) {
          config.headers.Authorization = `Bearer ${loginData.accessToken}`;
        }
      } catch (e) {
        console.error("Invalid JSON in loginData:", loginDataRaw);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
